import types from './types';

const defaultState = {
  hazardStatementList: [],
  euhStatementList: [],
  isLoading: false
};

export default (
  state = defaultState,
  {
    type,
    params,
    request /* using takeQuery: the initier action is set here */,
    data /* using takeQuery: query result will be set here */,
    ...action
  }
) => {
  switch (type) {
    case types.GET_HAZARD_STATEMENT_AUTOCOMPLETE_LIST:
    case types.GET_EUH_STATEMENT_AUTOCOMPLETE_LIST:
      return { ...state, isLoading: true };
    case types.GET_HAZARD_STATEMENT_AUTOCOMPLETE_LIST_SUCCESS:
      return { ...state, hazardStatementList: data, isLoading: false };
    case types.GET_EUH_STATEMENT_AUTOCOMPLETE_LIST_SUCCESS:
      return {...state, euhStatementList: data, isLoading: false};
    case types.GET_EUH_STATEMENT_AUTOCOMPLETE_LIST_FAILURE:
    case types.GET_HAZARD_STATEMENT_AUTOCOMPLETE_LIST_FAILURE:
      return { ...state, isLoading: false };
    default:
      return state;
  }
};
